// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__V3sLc","right":"Footer_right__2ZliV","buttons":"Footer_buttons__28kAk"};